import { ItemResponse } from 'common/types'
import { TrayItemProductDetails } from 'lib/services/api/product-service/receiveItems/types'

/**
 * Parses product details from either a JSON string or an existing object
 * @param productDetails - The product details to parse
 * @returns Parsed product details or undefined if invalid
 */
const parseProductDetails = (
  productDetails: string | object | null | undefined
): TrayItemProductDetails | undefined => {
  if (!productDetails) {
    return undefined
  }

  try {
    // If it's already an object, return it as is
    if (typeof productDetails === 'object') {
      return productDetails as TrayItemProductDetails
    }

    // If it's a string, parse it
    if (typeof productDetails === 'string') {
      return JSON.parse(productDetails) as TrayItemProductDetails
    }

    return undefined
  } catch (error) {
    console.error('Error parsing product details:', error)
    return undefined
  }
}

/**
 * Extracts and parses tray JSON data from an ItemResponse
 * @param trayItem - The tray item to extract data from
 * @returns Parsed tray product details or undefined if invalid/missing
 */
export const extractTrayJSONData = (
  trayItem: ItemResponse | null
): TrayItemProductDetails | undefined => {
  if (!trayItem) {
    return undefined
  }

  const trayDetails = parseProductDetails(trayItem.productDetails)

  // Enrich with sub-item data if necessary
  return trayDetails
}
